import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    useTheme,
    Zoom,
    Box,
    alpha,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const typeConfig = {
    info: { icon: InfoOutlinedIcon, color: "info.main" },
    warning: { icon: WarningAmberIcon, color: "warning.main" },
    error: { icon: ErrorOutlineIcon, color: "error.main" },
};

const AlertDialog = ({
    open,
    onClose,
    title,
    content,
    type = "info",
    onConfirm,
    confirmText = "OK",
    cancelText = "Cancel",
}) => {
    const theme = useTheme();
    const { icon: IconComp, color } = typeConfig[type] || typeConfig.info;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            TransitionComponent={Zoom}
            transitionDuration={200}
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    backgroundImage: "none",
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    backdropFilter: "blur(12px)",
                    border: `1px solid ${theme.palette.glass?.border || theme.palette.divider}`,
                    boxShadow: theme.palette.glass?.shadow || theme.shadows[10],
                    maxWidth: 380,
                    width: "100%",
                    mx: 2,
                },
            }}
            slotProps={{
                backdrop: {
                    sx: { backdropFilter: "blur(4px)", backgroundColor: alpha("#000", 0.5) },
                },
            }}
        >
            <DialogTitle sx={{ pb: 1, display: "flex", alignItems: "center", gap: 1.5, fontWeight: 700 }}>
                <Box sx={{
                    width: 36, height: 36, borderRadius: 2,
                    display: "flex", alignItems: "center", justifyContent: "center",
                    backgroundColor: alpha(theme.palette[type]?.main || theme.palette.info.main, 0.1),
                }}>
                    <IconComp sx={{ color, fontSize: 20 }} />
                </Box>
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText sx={{ color: theme.palette.text.secondary, fontSize: "0.9rem" }}>
                    {content}
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ p: 2, gap: 1 }}>
                {onConfirm && (
                    <Button onClick={onClose} sx={{ fontWeight: 600 }} color="inherit">
                        {cancelText}
                    </Button>
                )}
                <Button
                    onClick={() => { if (onConfirm) onConfirm(); onClose(); }}
                    variant="contained"
                    autoFocus
                    color={type === "error" ? "error" : "primary"}
                    sx={{ fontWeight: 600 }}
                >
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AlertDialog;
